import { QuestionTagEnum, QuestionType } from "../../common/types/question";
import { genId } from "../store/NewQuestionStore";

export const qInit = (meta: QuestionTagEnum, section: string): QuestionType => {
    let q: QuestionType = { questionId: genId(), meta: meta, sectionId: section };
    return q;
}